/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.pageViewModule')
  .controller('PageViewHeaderController', [
    'unit',
    '$',
    '$cookies',
    '$document',
    '$element',
    '$http',
    '$rootScope',
    '$scope',
    '$state',
    '$timeout',
    '$translate',
    '$window',
    'Restangular',
    'AeroDialogService',
    'AnalyticsService',
    'AssignmentService',
    'BulbAuthService',
    'BulbBrowserService',
    'BulbBusyService',
    'BulbCKEStateService',
    'BulbCommentService',
    'BulbErrorService',
    'BulbInappropriateContentService',
    'BulbModalService',
    'BulbPageService',
    'BulbPresentationService',
    'BulbRecommendService',
    'BulbToastService',
    'BulbUnitService',
    'BulbUseTemplateModalService',
    'ErrorService',
    'HttpService',
    'SaveStateStore',
    'SerialSaveService',
    'UnitStateStore',
    'AUTH',
    'USE_TEMPLATE_TIMEOUT',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    PageViewHeaderController,
  ]);

/**
 * AngularJS controller for header of a page view.
 */
function PageViewHeaderController(
  unit,
  $,
  $cookies,
  $document,
  $element,
  $http,
  $rootScope,
  $scope,
  $state,
  $timeout,
  $translate,
  $window,
  Restangular,
  AeroDialogService,
  AnalyticsService,
  AssignmentService,
  BulbAuthService,
  BulbBrowserService,
  BulbBusyService,
  BulbCKEStateService,
  BulbCommentService,
  BulbErrorService,
  BulbInappropriateContentService,
  BulbModalService,
  BulbPageService,
  BulbPresentationService,
  BulbRecommendService,
  BulbToastService,
  BulbUnitService,
  BulbUseTemplateModalService,
  ErrorService,
  HttpService,
  SaveStateStore,
  SerialSaveService,
  UnitStateStore,
  AUTH,
  USE_TEMPLATE_TIMEOUT,
) {
  const that = this;
  this.currentUserPrefs = BulbAuthService.currentUser.prefs;
  this.unit = unit;
  this.page = BulbPageService.page;
  this.isPanelActive = false;
  this.isShareActive = false;
  this.isMobile = BulbBrowserService.isMobile();
  this.previewStateActive = ($state.current.name === 'preview_page' || $state.current.name === 'live_page');
  this.autoSaveOptions = {
    restId: that.page.unit.id,
    restCollection: 'units',
  };
  this.organizationId = BulbAuthService.currentUser.groupMemberships
    .filter((group) => group.type === 'ORGANIZATION')[0]?.groupId;

  this.userId = BulbAuthService.currentUser.id;

  this.assignmentCanAssign = BulbAuthService.currentUser.features.AssignmentAccountFeature.canAssign;

  /**
   * Can the current page be copied as a template.
   * @returns {boolean|*} true if it is valid to copy the page via the template feature.
   */
  this.canCopyTemplate = function canCopyTemplate() {
    return that.page.unit.template
      && (that.page.unit.unitType === 'PublishedPageUnit' || that.page.unit.isPublished);
  };

  this.updateArchivedCommentsEnabled = function updateArchivedCommentsEnabled() {
    // eslint-disable-next-line no-param-reassign
    BulbCommentService.showArchivedComments = !BulbCommentService.showArchivedComments;
    BulbCommentService.refreshBubbleButtons();
    BulbCommentService.api.updateAccountPreferences();
  };

  this.canEdit = BulbAuthService.currentUser.hasPermission(this.unit, AUTH.PERMISSIONS.UPDATE) && !this.unit.viewOnly;
  this.canDelete = BulbAuthService.currentUser.hasPermission(this.unit, AUTH.PERMISSIONS.DELETE);
  this.canArchivePage = BulbAuthService.currentUser.features.ArchiveFeature.enabled;
  // If the user can view the page, and it is not an archived page, that user can share it.
  this.canSharePage = BulbAuthService.currentUser.hasPermission(this.unit, AUTH.PERMISSIONS.READ)
    && !this.unit.archivedDate && !this.unit.viewOnly; // jshint ignore:line

  // Conditional that initially checks if the user has the ability to archive a page.
  if (this.canArchivePage) {
    if (BulbAuthService.currentUser.isAuthenticated()) {
      that.archiveReady = that.unit.isPublished && !that.unit.isModified;
    }
  }

  this.showQuestions = false;
  this.loadedQuestions = false;
  this.focusQuestion = false;

  BulbUnitService.fetchParent().then(() => {
    that.parentUnit = BulbUnitService.parentUnit;
    that.previousUnit = BulbUnitService.previousSibling;
    that.nextUnit = BulbUnitService.nextSibling;
  });

  /**
   * Check if page limit has been reached to free user..
   * @returns {boolean}
   */
  const showMaximumPublishedPageModal = () => (BulbAuthService.currentUser.features.PublishingFeature.maxPublishedPages !== -1
      && BulbAuthService.currentUser.metrics.numPublishedPages
      >= BulbAuthService.currentUser.features.PublishingFeature.maxPublishedPages
      && !BulbUnitService.currentUnit.isPublished);

  this.showingPanel = null;

  // Watcher for the event broadcast
  $scope.$on('togglePanel', () => {
    // Simulate a click on the button nested within the share-button component to open the share panel
    $element[0].querySelector('bulb-share-button button').click();
  });

  // Function for closing More Actions Dropdown
  this.closeMoreActionsDropDown = function closeMoreActionsDropDown() {
    Foundation.libs.dropdown.close($('#drop1'));
  };

  // This function toggles the panel being selected.
  // If the broadcast event comes from PageViewController.handleNavigationFromUnpublishedPage, broadcast
  // pending state change parameters for use by the PublishPanelController.
  // TODO: Much of this function references dead code.
  //       Merge conflicts left it unclear what the intended behavior was, and how much is still relevant.
  this.togglePanel = function togglePanel(panel, pendingStateChangeOnPublish) {
    if (pendingStateChangeOnPublish) {
      // eslint-disable-next-line no-param-reassign
      BulbPageService.pendingStateChangeOnPublish = pendingStateChangeOnPublish;
    }
    if (panel && panel !== that.showingPanel) {
      // Check if the user doesn't have unlimited published pages
      BulbAuthService.fetchCurrentUser().then(() => {
        // Check if the user has space to publish more pages
        // Or if the page is already published, so they can publish new changes to that page
        if (showMaximumPublishedPageModal()) {
          AeroDialogService.showDialog({
            svgIconName: 'b-plus-icon',
            title: $translate.instant('error_too_many_published_pages_header_text'),
            detail: $translate.instant('error_too_many_published_pages_modal_text'),
            primaryLabel: $translate.instant('button_upgrade'),
            iconClass: 'aero-highlight',
            styleClass: 'aero-bulb-plus-icon',
            onPrimary: () => {
              BulbAuthService.planlistState();
            },
          });
          return;
        }
        that.showingPanel = panel;
        that.isPanelActive = true;
      });
    } else {
      that.showingPanel = null;
      that.isPanelActive = false;
    }
    if (panel === 'share') {
      that.isShareActive = !that.isShareActive;
      that.showingPanel = panel;
      const $shareButton = $('.bulb-page-header-share-button');
      if (!that.isShareActive) {
        that.showingPanel = null;
        $shareButton.focus();
      }
      $shareButton.attr('aria-expanded', that.isShareActive);
    } else if (panel === 'publish') {
      const $publishPanelButton = $('.publish-panel-button');
      if (!that.isPanelActive) {
        $publishPanelButton.focus();
      }
      $publishPanelButton.attr('aria-expanded', that.isPanelActive);
    }
  };

  /**
   * Refreshes the current view by reloading the current state.
   */
  this.refreshView = function refreshView() {
    $state.reload();
  };

  /**
   * Register global refreshView listener.
   */
  this.$onInit = function onInit() {
    window.addEventListener('refreshView', that.refreshView);
  };

  /**
   * Cleanup listener on controller destroy.
   */
  $scope.$on('$destroy', () => {
    window.removeEventListener('refreshView', that.refreshView);
  });

  /**
   * Toggle whether the current user has hidden the title for the current page.
   */
  const toggleTitleHidden = function toggleTitleHidden($event) {
    $event.stopPropagation();
    $event.preventDefault();

    that.page.unit.titleHidden = !that.page.unit.titleHidden;
    const payload = {
      titleHidden: that.page.unit.titleHidden,
      headerEffectType: 'NO_EFFECT',
    };
    SerialSaveService.save({
      save: () => Restangular.one('units', that.autoSaveOptions.restId).customPOST(payload, 'update'),
    });
  };

  /**
   * When a user toggles the template control on, if the page is currently unshared then we need to call a share api to
   * share the current page and if the page is already shared then calling publish api to republish the current changes.
   *
   * @param unitId the page id.
   * @param template hold the use template button state.
   */
  function publishOrSharePage(unitId, template) {
    if (template && BulbUnitService.currentUnit.isPublished) {
      const headers = {
        'X-XSRF-TOKEN': $cookies.get('XSRF-TOKEN'),
      };
      $http.post(`/b/rest/units/${unitId}/publish`, headers);
    } else {
      const unitPermissions = {
        privacyLevel: { level: 'CUSTOM' },
        permissions: [],
      };
      HttpService.savePermissions(unitId, unitPermissions).pipe().subscribe(() => {
        UnitStateStore.transitionShareStatus('SHARE');
      });
    }
  }

  /**
   * Refreshes the current view by reloading the current state.
   */
  this.refreshView = function refreshView(event) {
    const newPath = event?.detail?.unitPath;

    if (!newPath) {
      // fallback: just reload current state
      $state.reload();
      return;
    }

    $state.go('unit', {
      unitPath: newPath,
      published: $state.params.published,
      sharedLink: $state.params.sharedLink,
      uid: $state.params.uid,
      context: $state.params.context,
    }, {
      reload: true,
    });
  };

  /**
   * Register global refreshView listener.
   */
  this.$onInit = function onInit() {
    window.addEventListener('refreshView', that.refreshView);
  };

  /**
   * Cleanup listener on controller destroy.
   */
  $scope.$on('$destroy', () => {
    window.removeEventListener('refreshView', that.refreshView);
  });

  // Toggles the recommend/like for the page by the user.
  const toggleRecommend = function toggleRecommend() {
    // Yes, we mean "this" here, not "that".
    // As in, this function's scope, not the controller's scope.
    const thisMenuItem = this;
    if (that.unit.likedByUser) {
      BulbRecommendService.deleteRecommend(that.unit).then(() => {
        that.unit.likedByUser = false;
        that.unit.likeCount -= 1;
        thisMenuItem.icon = 'heart';
        thisMenuItem.label = $translate.instant('button_like');
      });
    } else {
      BulbRecommendService.createRecommend(that.unit).then(() => {
        that.unit.likedByUser = true;
        that.unit.likeCount += 1;
        thisMenuItem.icon = 'heart-solid';
        thisMenuItem.label = $translate.instant('button_liked');
      });
    }
  };

  /**
   * Function that toggle whether the page is saved as a template.
   * @param $event event triggered.
   */
  const toggleTemplateButton = function toggleTemplateButton() {
    // Set the view model data to update the template
    that.page.unit.template = !that.page.unit.template;
    SerialSaveService.save({
      save: () => Restangular.one('units', that.page.unit.id)
        .customPOST({ template: that.page.unit.template }, 'update'),
    }).then(publishOrSharePage(that.page.unit.id, that.page.unit.template));
  };

  /**
   * Function that archives the currently published page.
   * @param event event triggered.
   */
  this.archivePage = function archivePage(event) {
    const modalOptions = {
      fontAwesomeCode: 'fas fa-inbox',
      titleCode: 'archive_modal_title',
      bodyCode: 'archive_modal_body_text',
      okButtonCode: 'archive_modal_archive_button',
      showCancelButton: true,
      windowClass: 'bulb-aero-modal-body bulb-aero-modal-buttons bulb-pageview-dashboard-archive-modal',
      focusAfterClosed: event.currentTarget,
      // TODO TAM clean: Name is going to change from the refactor that I did.
    };

    // Show the Archive Page Modal
    BulbModalService.show(modalOptions).then(() => {
      // Actually create the archive page
      SerialSaveService.save({
        showBusy: true,
        save: () => Restangular.one('units', that.unit.id)
          .customPOST({}, 'copyTemplate', { isArchive: true })
          .then(() => {
            // Logic that displays the toast to the user that the page has been archived
            let message = $translate.instant('pageview_archived_page');
            message += '!';
            BulbToastService.show(message);
            // There is here for the sole reason of being able to unit test this function. Since no
            // Data is sent back from the REST call to the server, we need a way of knowing that the archive
            // Was successful. TODO TAM clean: think of a better way to do this.
            that.archivedSuccessfully = true;
          }),
      });
    });
  };

  /**
   * Method that is called from deleteResumeUnitModal and deleteUnitModal. To delete a page you should call delete()
   */
  function deleteUnitWithoutModal() {
    $rootScope.$broadcast('navigationAwayApproval', true);

    // user confirmed the confirm delete modal
    BulbBusyService.showBusyDuring(
      BulbUnitService.deleteUnit(that.unit).then(() => {
        BulbAuthService.fetchCurrentUser();
        if (that.parentUnit && that.parentUnit.unitType !== 'UserUnit') {
          $state.go('unit', { unitPath: that.parentUnit.path });
        } else {
          $state.go('author', { username: BulbAuthService.currentUser.username });
        }
      }, (error) => {
        BulbErrorService.error('Cannot delete page', error);
      }),
    );
  }

  /**
   * Shows the 'delete unit modal' for units attached to resume, private function.
   * To delete a page you should call deletePage()
   */
  function deleteResumeUnitModal() {
    BulbModalService.show({
      titleCode: 'soft_delete_resume_title',
      bodyCode: 'soft_delete_resume_body',
      okButtonCode: 'button_delete',
      cancelButtonCode: 'button_cancel',
      fontAwesomeCode: 'far fa-trash-alt',
      windowClass: 'updated-modal-design bulb-aero-modal bulb-delete-resume-confirmation',
      windowId: 'bulb-delete-resume-confirmation-modal',
    }).then(() => {
      deleteUnitWithoutModal();
    });
  }

  /**
   * Shows the standard delete unit modal, private function. To delete a page you should call delete()
   */
  function deleteUnitModal() {
    const translatedType = $translate.instant('type_draft_page_unit');
    const typeToLowercase = translatedType.toLowerCase();

    AeroDialogService.showDialog({
      icon: 'far fa-trash-alt',
      iconClass: 'aero-alert',
      title: $translate.instant('modal_delete_confirm_title', { type: typeToLowercase }),
      detail: $translate.instant('soft_delete_modal_delete_type_confirm_page', { type: typeToLowercase }),
      primaryLabel: $translate.instant('button_delete'),
      primaryStyle: AeroDialogService.getButtonStyleEnum().NEGATIVE_ACTION,
      onPrimary: () => {
        deleteUnitWithoutModal();
      },
    });
  }

  // Allows the user to 'soft' delete the page. Deleting a page from resume has a different modal than deleting a
  // standard unit, this determines if the page is used within resume and if so shows the alternative modal.
  this.deletePage = function deletePage() {
    if (BulbAuthService.currentUser.features.ResumeFeature.resumeEnabled && that.unit.isAttachedToResume) {
      deleteResumeUnitModal();
    } else {
      deleteUnitModal();
    }
  };

  // This function lets the user go back in a couple of different scenarios, depending on where they came from,
  // and their status of currently being logged in.
  // NOTE: A user can only reach this function if they are logged in.
  this.handleBackArrow = function handleBackArrow() {
    // Leveraging this service to tie the handleBackArrow functionality between this and the publishpanel-controller
    // in order to improve how navigating is handled.
    // eslint-disable-next-line no-param-reassign
    BulbPageService.userClickedBackArrow = true;

    // If there is no previousState, that means we came from somewhere that isn't bulb.
    // If there is a previousState, that means it was stored successfully, and we need to navigate to that.
    // We never want to go 'back' to the snapshot_view as it acts more like a dialog,
    // it will also cause an infinite routing loop if we do go back to it.
    if (!$state.previousState || $state.previousState.name === 'snapshot_preview') {
      $state.go('author', { username: unit.ownerUsername });
    } else {
      $state.go($state.previousState.name, $state.previousState.params);
    }
  };

  // This function handles clicking the bulb logo and navigates the user to the place they need to go accordingly.
  this.handleBulbLogoNavigation = function handleBulbLogoNavigation() {
    // This is if they're logged in.
    if (BulbAuthService.currentUser.username !== 'Anonymous') {
      $state.go('author', { username: BulbAuthService.currentUser.username });
    } else {
      window.location.href = '/';
    }
  };

  // Handles signing in as needed.
  this.signIn = function signIn() {
    $state.go('signIn', { targetUrl: $window.location.href });
  };

  /**
   * Shows the page snapshot dialog and saves the event in the analytics service.
   */
  this.tagPage = function tagPage() {
    const dialog = AeroDialogService.showStudentTagsDialog(null, that.page.unit);

    const subscription = dialog.onClose.subscribe(() => {
      subscription.unsubscribe();
      $state.reload();
    });
  };

  /**
   * Shows the page snapshot dialog and saves the event in the analytics service.
   */
  this.assignPage = function assignPage() {
    AssignmentService.showAssignPageDialog(this.unit.id, false);
    const assignPageAnalyticEvent = {
      event: 'AssignPageClick',
    };
    AnalyticsService.pushEvent(assignPageAnalyticEvent);
  };

  this.showPageInfo = function showPageInfo() {
    const pageInfoModalOptions = {
      templateUrl: 'page-info-modal.nested',
      titleCode: 'page_information_title',
      okButtonCode: 'page_information_button',
      showCancelButton: false,
      fontAwesomeCode: 'far fa-info-circle',
      windowClass: 'bulb-aero-modal-body bulb-aero-modal-buttons bulb-aero-modal-buttons-single-btn page-info-modal',
      controllerAs: 'vm',
      controller: function showPageInfoController() {
        const vm = this;
        vm.page = BulbPageService.page;

        vm.autoSaveOptions = {
          restId: vm.page.unit.id,
          restCollection: 'units',
        };
      },
    };

    BulbModalService.show(pageInfoModalOptions);
  };

  /**
   * Shows the page snapshot dialog and saves the event in the analytics service.
   */
  this.showPageSnapshots = function showPageSnapshots() {
    const dialog = AeroDialogService.showSnapshotDialog(this.unit.id, this.unit.draftPageId);

    const subscription = dialog.onClose.subscribe(() => {
      AeroDialogService.removeDialog();
      subscription.unsubscribe();
    });

    const pageSnapshotAnalyticEvent = {
      event: 'PageSnapshotDialogClick',
    };
    AnalyticsService.pushEvent(pageSnapshotAnalyticEvent);
  };

  /**
   * Reverts the page to the specific snapshot and saves the analytics event.
   */
  this.revertToSnapshot = function revertToSnapshot() {
    SerialSaveService.save({
      save: () => Restangular.one('units', $state.params.draftPageId)
        .one('snapshots', $state.params.snapshotId).one('restore')
        .patch()
        .then(() => {
          const pageSnapshotAnalyticEvent = {
            event: 'PageSnapshotRevertPageClick',
          };
          AnalyticsService.pushEvent(pageSnapshotAnalyticEvent);

          $state.go('unit', { unitPath: this.unit.id });
        }),
    });
  };

  /**
   * Navigates the user back from the snapshot view.
   */
  this.cancelSnapshotPreview = function cancelSnapshotPreview() {
    $state.go('unit', { unitPath: this.unit.id });
  };

  /**
   * Navigates the user to next snapshot view.
   */
  this.changeSnapshot = function changeSnapshot(currentTimestamp, changeState) {
    const slideSnapshot = new CustomEvent('changeSnapshot', {
      detail: {
        currentTimestamp,
        changeState,
      },
    });
    // Dispatch the event:
    window.dispatchEvent(slideSnapshot);
  };

  // This function makes it so that if you click anywhere on the page, the current showing panel will close.
  // Also, if you click the panel itself, it will not close. It will only close if you click elsewhere on the page.
  function documentClick(event) {
    const previewLiveViewBody = $('.bulb-page-panel');
    if ((!previewLiveViewBody.is(event.target) && previewLiveViewBody.has(event.target).length === 0)) {
      that.showingPanel = null;
    }
  }

  // This function handle the toggling of publish panel.
  function handlePublishPanelToggling() {
    const isMoreMenuOpen = $('#drop1').hasClass('open');
    if (isMoreMenuOpen) {
      that.closeMoreActionsDropDown();
    }
  }

  // if ESC is pressed when the panel is open, the panel will close.
  // This function shouldn't be called on the more option panel with the enter key pressed on the links.
  function documentKeyUp(event) {
    if ((event.key && (event.key === 'Escape') && (event.key !== 'Enter'))) {
      handlePublishPanelToggling();
    }
  }

  // We register the click handler here.
  $document.on('click', documentClick);

  // Toggle panel when ESC press
  $document.on('keyup', documentKeyUp);

  const closePublishPanel = $rootScope.$on('closePublishPanel', documentClick);

  $scope.$on('$destroy', () => {
    $document.off('click', documentClick);
    // deregister closePublishPanel listener
    closePublishPanel();
  });

  $scope.$on('$destroy', () => {
    $document.off('keyup', documentKeyUp);
  });

  /**
   * When there is any change in the page title, we need to update the template button accordingly. If there is no page
   * title or user reached the maximum published pages limit, disabled the template toggle button with description.
   * Otherwise, show the template toggle button.
   */
  $scope.$watch(() => that.page.unit.name, (value) => {
    const { maxPublishedPages } = BulbAuthService.currentUser.features.PublishingFeature;

    // To check if the current user reached the maximum published page limit
    const isMaxPublishedPageLimitReached = maxPublishedPages !== -1
      && BulbAuthService.currentUser.metrics.numPublishedPages >= maxPublishedPages;

    const template = this.pageMenuItems.find((x) => x.name === 'useTemplate');
    const assign = this.pageMenuItems.find((x) => x.name === 'assign');

    assign.disabled = value === '' || !this.assignmentCanAssign;

    /**
     * Shows b+ icon on the right side of the menu item if the item is both disabled and
     * the current user does not have canAssign enabled or show a help icon.
     */
    if (assign.disabled && !this.assignmentCanAssign) {
      assign.descriptiveIconSrc = '../../resources/images/menus/bulb_plus_icon.svg';
      assign.descriptiveIconStyle = 'menu-item__descriptive-icon--bulb-plus';
    } else {
      assign.descriptiveIconSrc = '../../resources/images/menus/circle-info-light.svg';
      assign.descriptiveIconStyle = 'menu-item__descriptive-icon--bulb-info';
      assign.descriptiveIconLabel = $translate.instant('help_icon');
      assign.descriptiveIconURL = 'https://www.bulbapp.com/u/meet-bulb-s-%F0%9F%86%95-assignment-feature';
    }

    /**
     * If the current user has assignmentCanAssign but the title is empty, we provide helper text
     * on the right side of the menu item to explain why the menu item is disabled
     */
    assign.descriptiveText = value === '' && this.assignmentCanAssign
      ? $translate.instant('pageview_title_to_enable') : '';

    // Disabled the template button if either page title is blank or current user reached the maximum
    // published page limit.
    template.disabled = value === ''
      || isMaxPublishedPageLimitReached
      || !BulbAuthService.currentUser.features.TemplateFeature.enabled;

    template.type = (template.disabled) ? '' : 'TOGGLE';
    template.icon = (template.disabled) ? 'exclamation-square' : 'clone';

    if (!BulbAuthService.currentUser.features.TemplateFeature.enabled) {
      template.descriptiveIconSrc = '../../resources/images/menus/bulb_plus_icon.svg';
      assign.descriptiveIconStyle = 'menu-item__descriptive-icon--bulb-plus';
    } else if (template.disabled) {
      template.descriptiveText = $translate.instant('pageview_title_to_enable');
    } else {
      template.descriptiveText = '';
    }
  });

  /**
   * REST request to server to copy a page as a template.
   * If there is not enough space on the users account to fully copy all the assets an error is thrown
   *
   * @param event event triggered
   */
  this.copyPageAsTemplate = function copyPageAsTemplate(event) {
    if (BulbAuthService.currentUser.isAuthenticated()) {
      // If the user does not have the TemplateFeature enabled, show premium modal
      if (!BulbAuthService.currentUser.features.TemplateFeature.enabled) {
        AeroDialogService.showPlanUpgradeDialog();
        return;
      }

      const ref = BulbUseTemplateModalService.useTemplateCopyingModal();

      const useTemplateCopyTimeout = $timeout(() => {
        ref.close();
        BulbUseTemplateModalService.showErrorModal(event);
      }, USE_TEMPLATE_TIMEOUT);

      SerialSaveService.save({
        save: () => Restangular.one('units', that.unit.id)
          .customPOST({}, 'copyTemplate', { isArchive: false })
          .then(() => {
            $timeout.cancel(useTemplateCopyTimeout);
            ref.destroy();
            BulbUseTemplateModalService.useTemplateCopiedModal(event, that.unit.id, 'Page');
          }),
      }).catch((error) => {
        $timeout.cancel(useTemplateCopyTimeout);
        ref.close();
        if (error && error.data.developerMessage
          && error.data.developerMessage.indexOf('use_template_cke_error_modal_body') !== -1) {
          BulbUseTemplateModalService.showErrorModal(event, 'use_template_cke_error_modal_body', false, true);
        } else if (error && error.data.developerMessage
          && error.data.developerMessage.indexOf('tag_usage_limit_exceeded') !== -1) {
          BulbErrorService.showError($translate.instant('tag_usage_limit_exceeded'));
        } else {
          BulbErrorService.showError($translate.instant('error_iFramely_url_not_found'));
        }
      });
    } else {
      BulbUseTemplateModalService.useTemplateSigninModal();
    }
  };

  /**
   * Share Controls:
   * These methods and variables are used by 'share-panel.module' components.
   */

  const getType = function getType() {
    // get unit type
    let type;
    switch (that.page.unit['@c']) {
      case '.PageUnitDTO':
        type = 'page';
        break;
      case '.CompositeUnitDTO':
        type = 'collection';
        break;
      case '.UserUnitDTO':
        type = 'profile';
        break;
      case '.GroupDTO':
        type = 'group';
        break;
      default:
        type = 'page';
    }
    return type;
  };

  // These MenuItems get updated when pageState changes.
  const pageMenuItems = [
    {
      label: $translate.instant('pageview_preview_live_mode_text'),
      icon: 'eye',
      command: () => that.togglePanel('view'),
      closeMenuOnClick: true,
      hidden: !that.canEdit,
    },
    {
      label: 'Tags',
      iconSrc: '../../resources/images/menus/tags.svg',
      command: () => that.tagPage(),
      closeMenuOnClick: true,
      hidden: !that.canEdit,
    },
    {
      label: $translate.instant('assignment_triple_dot_label'),
      name: 'assign',
      iconSrc: '../../resources/images/menus/assign_triple_arrow.svg',
      hidden: !BulbAuthService.currentUser.features.AssignmentAccountFeature.assignIsVisible
        || ['EDUCATOR', 'ADMINISTRATOR'].indexOf(BulbAuthService.currentUser.position) === -1
        || !that.canEdit,
      closeMenuOnClick: true,
      command: () => that.assignPage(),
      disabledAction: () => {
        if (!this.assignmentCanAssign) {
          AeroDialogService.showPlanUpgradeDialog();
        }
      },
    },
    {
      label: $translate.instant('pageview_save_as_template'),
      model: that.page.unit.template,
      hidden: !that.canEdit,
      name: 'useTemplate',
      closeMenuOnClick: true,
      command: () => {
        toggleTemplateButton();
        pageMenuItems[3].model = that.page.unit.template;
      },
      disabledAction: () => {
        AeroDialogService.showPlanUpgradeDialog();
      },
    },
    {
      label: $translate.instant('page_history_header_title'),
      icon: 'history',
      command: () => that.showPageSnapshots(),
      closeMenuOnClick: true,
      hidden: !that.canEdit,
    },
    {
      label: that.page.unit.titleHidden
        ? $translate.instant('title_show_text')
        : $translate.instant('title_hide_text'),
      icon: that.page.unit.titleHidden ? 'eye' : 'eye-slash',
      command: ($event) => {
        toggleTitleHidden($event);
        pageMenuItems[5].label = that.page.unit.titleHidden
          ? $translate.instant('title_show_text')
          : $translate.instant('title_hide_text');
        pageMenuItems[5].icon = that.page.unit.titleHidden ? 'eye' : 'eye-slash';
      },
      hidden: !that.canEdit,
    },
    {
      label: $translate.instant('pageview_toggle_question_and_answer_text'),
      icon: 'comment',
      type: 'TOGGLE',
      model: that.page.unit.questionsDisabled,
      hidden: (!that.canEdit || !that.page.unit.hasQuestions
        || !BulbAuthService.currentUser.features.SharingFeature.questionAndAnswer),
      command: () => {
        that.page.unit.questionsDisabled = !that.page.unit.questionsDisabled;
        pageMenuItems[6].model = that.page.unit.questionsDisabled;

        SerialSaveService.save({
          save: () => Restangular.one('units', that.page.unit.id)
            .customPOST({ questionsDisabled: that.page.unit.questionsDisabled }, 'update'),
        });
      },
    },
    {
      // FUTURE JDK BULB-2859 : This is temporarily disabled until the custom work for CKEditor commenting is completed
      label: $translate.instant('comment_show_archived_comments'),
      icon: 'archive',
      type: 'TOGGLE',
      model: that.currentUserPrefs.showArchivedComments,
      hidden: true, // !that.canEdit || !BulbAuthService.currentUser.features.CommentingFeature.enabled
      command: () => {
        that.updateArchivedCommentsEnabled();
        pageMenuItems[7].model = that.currentUserPrefs.showArchivedComments;
      },
    },
    {
      label: $translate.instant('comment_text'),
      icon: 'comment',
      type: 'TOGGLE',
      model: that.page.unit.commentsEnabled,
      hidden: !that.canEdit || !BulbAuthService.currentUser.features.CommentingFeature.enabled,
      command: () => {
        that.page.unit.commentsEnabled = !that.page.unit.commentsEnabled;
        BulbCKEStateService.isCommentEnabledSubject.next(this.page.unit.commentsEnabled);
        pageMenuItems[8].model = that.page.unit.commentsEnabled;

        SerialSaveService.save({
          save: () => Restangular.one('units', that.page.unit.id)
            .customPOST({ commentsEnabled: that.page.unit.commentsEnabled }, 'update'),
        }).then(() => {
          $window.location.reload();
        });
      },
    },
    {
      label: $translate.instant('button_template'),
      icon: 'clone',
      command: ($event) => that.copyPageAsTemplate($event),
      disabled: !that.page.unit.template,
      hidden: !that.canCopyTemplate() || BulbAuthService.currentUser.isAuthenticated(),
    },
    {
      label: that.unit.likedByUser ? $translate.instant('button_liked') : $translate.instant('button_like'),
      icon: that.unit.likedByUser ? 'heart-solid' : 'heart',
      command() {
        toggleRecommend.bind(this).call();
      },
      hidden: !BulbAuthService.currentUser.isAuthenticated() || this.unit.viewOnly,
    },
    {
      label: $translate.instant('page_information_title'),
      icon: 'info-circle',
      command: () => that.showPageInfo(that.page.unit),
      closeMenuOnClick: true,
      hidden: !that.canEdit,
    },
    {
      label: $translate.instant('pageview_share_button'),
      icon: 'telegram-plane',
      command: () => that.togglePanel('share'),
      hidden: !that.canSharePage || !that.isMobile,
    },
    {
      label: $translate.instant('button_present'),
      icon: 'caret-square-right',
      command: () => BulbPresentationService.startPresentation(that.unit),
      hidden: !BulbAuthService.currentUser.isAuthenticated()
        || !BulbAuthService.currentUser.features.PresentationFeature.enabled || this.unit.viewOnly,
    },
    {
      label: $translate.instant('pageview_get_help_text'),
      icon: 'question-circle',
      type: 'LINK',
      link: 'https://help.bulbapp.com/',
    },
    {
      label: $translate.instant('pageview_archive_page'),
      descriptiveText: !that.archiveReady
        ? $translate.instant('pageview_archive_explanation')
        : '',
      icon: 'inbox',
      command: ($event) => that.archivePage($event),
      disabled: !that.archiveReady,
      hidden: !that.canEdit || !that.canArchivePage,
    },
    {
      label: $translate.instant('pageview_report_page'),
      icon: 'flag',
      command: ($event) => BulbInappropriateContentService.openModal($event, that.unit),
      hidden: that.canEdit || this.unit.viewOnly,
    },
    {
      label: $translate.instant('pageview_delete_page'),
      icon: 'trash-alt',
      command: () => that.deletePage(),
      hidden: !that.canDelete,
      color: 'var(--bulb-darker-red-color)',
    },
  ];

  that.commandsForAngular = {
    copyPageAsTemplate: ($event) => that.copyPageAsTemplate($event),
  };

  function updatePageStateForAngular() {
    pageMenuItems[15].disabled = !that.archiveReady;
    pageMenuItems[15].descriptiveText = !that.archiveReady
      ? $translate.instant('pageview_archive_explanation')
      : '';

    that.pageState = {
      canEdit: BulbAuthService.currentUser.hasPermission(that.unit, AUTH.PERMISSIONS.UPDATE),
      isAuthenticated: BulbAuthService.currentUser.isAuthenticated(),
      isShareDisabled: !that.page.unit.name || that.page.unit.name === '',
      viewPanelShowing: that.showingPanel === 'view',
      isTemplate: that.page.unit.template,
      type: that.page.unit.unitType,
      viewType: getType(),
      isSharedLimitReached: showMaximumPublishedPageModal(),
      features: {
        SharingFeature: BulbAuthService.currentUser.features.SharingFeature,
        CommentingFeature: BulbAuthService.currentUser.features.CommentingFeature,
        PresentationFeature: BulbAuthService.currentUser.features.PresentationFeature,
      },
    };
  }

  that.page.unit.template = this.page.unit.template;
  that.pageMenuItems = pageMenuItems;
  updatePageStateForAngular();

  // Listen for successful saves of the current page, and update the 'publish' status when it happens
  const ShareStatus = UnitStateStore.getShareStatusEnum();

  if (UnitStateStore.getShareStatus() === ShareStatus.MODIFIED && that.page.unit.name) {
    BulbPageService.publishWithoutReload(that.page).then(() => {
      UnitStateStore.transitionShareStatus('SHARE');
    })
      .catch((error) => {
        BulbModalService.show({
          titleCode: 'server_error_title',
          bodyCode: 'server_error_body_code',
          showCancelButton: false,
        });
        ErrorService.captureErrorMessage(error);
      });
  }

  const shareStatusSub = UnitStateStore.shareStatus$.subscribe((shareStatus) => {
    switch (shareStatus) {
      case ShareStatus.MODIFIED:
        if (that.page.unit.name) {
          this.archiveReady = false;
        }
        break;

      case ShareStatus.SHARED:
        this.page.unit.isPublished = true;
        if (this.canArchivePage) {
          this.archiveReady = true;
        }
        break;

      case ShareStatus.PRIVATE:
        this.page.unit.isPublished = false;
        if (this.canArchivePage) {
          this.archiveReady = false;
        }
        break;

      default:
        break;
    }

    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    updatePageStateForAngular();
  });

  // Watch for saves to update page state
  const SaveStatus = SaveStateStore.getStatusEnum();
  const saveStatusSub = SaveStateStore.status$.subscribe((status) => {
    if (status === SaveStatus.SAVED) {
      updatePageStateForAngular();
    }
  });
  /**
   * Call to show limit reached modal.
   */
  const showSharedLimitModal = () => {
    that.togglePanel('view');
  };

  $scope.$on('$destroy', () => {
    shareStatusSub.unsubscribe();
    saveStatusSub.unsubscribe();
    window.removeEventListener('showSharedLimitModal', showSharedLimitModal);
  });

  /**
   * Call from share component when free user will click on share.
   */
  window.addEventListener('showSharedLimitModal', showSharedLimitModal);
}
